var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"bg-header position-absolute w-100",style:({ 'border-bottom-color': _vm.borderColor })}),_c('b-container',{staticClass:"app-container mx-auto my-0",attrs:{"fluid":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }